'use client'

import cx from 'classnames'
import React, { useState } from 'react'

import ULink from '@/components/Link/ULink'
import '@/components/Sort/Sort.scss'

type Props = {
  title: string
  nextLink?: boolean
  links: {
    name: string
    href: string
  }[]
}
export default function Sort({ title, links, nextLink = true }: Props) {
  const [open, setOpen] = useState(false)

  return (
    <div
      className={cx('c-sort', {
        'is-open': open,
      })}
    >
      <div className="c-sort__heading" onClick={() => setOpen((prevState) => !prevState)}>
        <div className="c-sort__heading-anchor">
          <h2 className="c-sort__heading-title">{title}</h2>
          <figure className="c-sort__heading-arrow">
            <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.32557 7L0.465105 4.76995e-08L3.32556 2.33333L6.18603 -4.76837e-07L3.32557 7Z" fill="black" />
            </svg>
          </figure>
        </div>
      </div>
      <ul className="c-sort__list">
        {links.map((link) => {
          return (
            <li className="c-sort__list-item u-mo-crop" key={link.name}>
              <ULink
                href={link.href}
                nextLink={nextLink}
                className="c-sort__list-anchor u-mo-crop__container"
                onClick={() => setOpen(false)}
              >
                <span className="u-mo-crop__text u-mo-crop__text--inner">{link.name}</span>
                <span className="u-mo-crop__text u-mo-crop__text--outer">{link.name}</span>
              </ULink>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
